module.exports = __webpack_public_path__ + "media/uplifting-bells-notification-938-2.30d511ac.wav";